import { createListCollection } from "@chakra-ui/react";

export const TIME_OPTIONS_ARR = Array.from({ length: 25 }).reduce((acc, _, index) => {
    const hour = Math.floor(index / 2) + 8;
    const minutes = index % 2 === 0 ? "00" : "30";
    const timeValue = `${hour.toString().padStart(2, "0")}:${minutes}`;

    if (hour < 20 || (hour === 20 && minutes === "00")) {
        acc.push({ value: timeValue, label: timeValue });
    }

    return acc;
}, []);

export const timeOptionsCollection = createListCollection({
    items: TIME_OPTIONS_ARR,
});
